<div class='m-1'>
    <div *ngIf="!isReadOnly" class="add-note">
        <h5>Add New Note</h5>
        <form [formGroup]="addNoteForm"
              (ngSubmit)="addNote(addNoteForm)">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <textarea class="form-control message-input" formControlName="Message"></textarea>
                    </div>
                </div>
            </div>
            <div class="actions">
                <button type="button" class="btn btn-info cancel-button"
                        (click)="cancelAddNote()">Cancel</button>
                <button type="submit" class="btn btn-primary ms-sm-2 add-note-button"
                        *ngIf="!currentNote"
                        [disabled]="addNoteForm.invalid"
                        [ladda]="busy">Add Note</button>
                <button type="submit" class="btn btn-primary ms-sm-2 update-note-button"
                        *ngIf="currentNote"
                        [disabled]="addNoteForm.invalid || addNoteForm.pristine"
                        [ladda]="busy">Update Note</button>
            </div>
        </form>
    </div>
    <div class="notes mt-5">
        <h5>Notes</h5>

        <p *ngIf="notes?.Results?.length === 0">There are not currently any notes available.</p>

        <ul class="notes-list" *ngIf="notes?.Results?.length > 0">
            <li *ngFor="let note of notes.Results | orderBy: 'Date'">
                <p><b [innerHtml]="note.CreatedBy"></b> (<i [innerHtml]="note.Date | date: 'MM/dd/yyyy hh:mm a'">  </i>) 
                    <span  
                        [class.bg-primary]="note.Visibility == 0" 
                        [class.bg-info]="note.Visibility == 1" 
                        class="badge"><i *ngIf="wasNoteSentInEmail(note)" class="fas fa-envelope"></i> {{getNoteVisibilityText(note)}}</span>
                </p>
                <p [innerHtml]="note.Message"></p>

                <ul class="actions edit-note-actions" *ngIf="canModifyNote(note)">
                    <li><a href="Javascript://" title="Edit" (click)="editNote(note)"><i class="fas fa-pencil-alt me-1"></i></a></li>
                    <li>
                        <ng-template #confirmDelete>
                            <div class="row">
                                <div class="col-sm-12">
                                    <p>Are you sure you want to delete this note?</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6 text-end">
                                    <button class="btn btn-danger" (click)="deleteNote(note); p.close()">Yes</button>
                                </div>
                                <div class="col-sm-6 text-start">
                                    <button class="btn btn-info" (click)="p.close()">Cancel</button>
                                </div>
                            </div>
                        </ng-template>
                        <a href="Javascript://" title="Delete"
                           [ngbPopover]="confirmDelete"
                           popoverTitle="Confirm"
                           triggers="manual"
                           placement="top"
                           container="body"
                           #p="ngbPopover" (click)="p.open()"><i class="fas fa-times"></i></a>
                    </li>
                </ul>
            </li>
        </ul>

        <!-- Size XS -->
        <ngb-pagination
            class="d-sm-none"
            *ngIf="notes?.TotalNumberPages > 1"
            [collectionSize]="notes?.TotalCount"
            [(page)]="currentPage"
            [pageSize]="notes?.Limit"
            [maxSize]="3"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="onPageChange()"></ngb-pagination>

        <!-- Size SM, MD, LG -->
        <ngb-pagination
            class="d-none d-sm-block d-xl-none"
            *ngIf="notes?.TotalNumberPages > 1"
            [collectionSize]="notes?.TotalCount"
            [(page)]="currentPage"
            [pageSize]="notes?.Limit"
            [maxSize]="5"
            (pageChange)="onPageChange()"></ngb-pagination>

        <!-- Size XL -->
        <ngb-pagination
            class="d-none d-xl-block"
            *ngIf="notes?.TotalNumberPages > 1"
            [collectionSize]="notes?.TotalCount"
            [(page)]="currentPage"
            [pageSize]="notes?.Limit"
            [maxSize]="10"
            (pageChange)="onPageChange()"></ngb-pagination>

    </div>
</div>